import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: space-evenly;
`

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`

export const RegisterDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3rem;
`

export const Image = styled.img`
  width: 10rem;
  height: 3rem;
  object-fit: contain;
`

export const Title = styled.p`
  margin: 0;
  text-align: center;
  font-size: 21px;
`

export const InputDiv = styled.div`
  min-width: 17rem;
  max-width: 40rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 1rem;
`

export const Field = styled.div`
  min-height: 4rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const Label = styled.label`
  font-size: 18px;
`

export const Input = styled.input`
  height: 2.5rem;
  width: 18rem;
  font-size: 18px;
  padding-left: 0.5rem;
`

export const ButtonDiv = styled.div`
  width: 17rem;
  display: flex;
  justify-content: center;
`

export const Button = styled.button`
  width: 14rem;
  height: 2.5rem;
  background-color: white;
  border-radius: 3px;
  color: #3370e5;
  border-color: #3370e5;
  border-width: 0.01rem;
  font-size: 18px;
  :hover {
    background-color: #3370e5;
    color: white;
  }
`

export const Image2 = styled.img`
  width: 50%;
  height: 100%;
  object-fit: contain;
`
export const LinkButton = styled(Link)`
  color: #3370e5;
  text-decoration: none;
`

export const LinkDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
